import { setURL } from '@/api/apiUtil'

export default {
  // 取得某社區的戶別列表
  getHouseholdList: {
    url: (communityId) =>
      setURL('/household/community/:communityId', { communityId }),
    method: 'get'
  },
  // 根據戶別編號取得住戶列表
  getResidentList: {
    url: (householdId) =>
      setURL('/resident/household/:householdId', { householdId }),
    method: 'get'
  },
  //匯入住戶
  importhouseholdList:{
    url: (communityId) =>
      setURL('/household/import/:communityId', { communityId }),
    method: 'post'
  }
}
